var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiDiscountCover = function SvgMultiDiscountCover(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.016,
    height: 25,
    fill: "none"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "multiDiscountCover_svg__a",
    x1: 0.739,
    x2: -0.338,
    y1: 1.265,
    y2: 0.754
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#C79B46"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EBCC7B"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#multiDiscountCover_svg__a)",
    d: "M1.2 0h54.81a1 1 0 0 1 1.006.994v23.012A1 1 0 0 1 56.01 25H11.484a7.945 7.945 0 0 1-7.826-6.42L.232 1.178A.98.98 0 0 1 1.2 0"
  })));
};
export default SvgMultiDiscountCover;